export const AgencyString = {
    zipcode:'CAP',
    province:'Provincia',
    province_symbol:'Simbolo della provincia',
    title: 'Organizzazione',
    addAgency: 'Aggiungi Organizzazione',
    name:'Nome',
    address: 'Indirizzo',
    city: 'Città',
    opening_date: 'Data Apertura',
    closing_date: 'Opputunity Attivo',
    actions: 'Azioni',
    status_active : 'Attivo',
    status_suspended : 'Sospeso',
    status_disabled : 'Disabilitato',
    status_expired : 'Scaduto',
    editAgency: 'Modifica Organizzazione',
    viewAgency: 'Visualizza Organizzazione',
    is_internal_backoffice: 'È Backoffice interno',
    is_institute_backoffice: 'È Backoffice instituto',
    type: 'Tipo',
    
    

}